import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MY_FORMATS } from '../../../_models/moment-formats';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ActualizacionDatosService } from '../actualizacion-datos.service';
import { PersonaUpdate } from 'src/app/_models/persona-update';
import { combineLatest, Observable, Subscription, BehaviorSubject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { map, tap, toArray, publishReplay, publishBehavior } from 'rxjs/operators';

@Component({
  selector: 'app-actualizacion-stepper',
  standalone: false,
  templateUrl: './actualizacion-stepper.component.html',
  styleUrls: ['./actualizacion-stepper.component.scss', '../actualizacion_datos.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ]
})
export class ActualizacionStepperComponent implements OnInit, OnDestroy {

  returnUrl: string;

  datosUbicacionForm: UntypedFormGroup = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    todosCheck: new UntypedFormControl(''),
    residenciaDireccion: new UntypedFormControl('', [Validators.required]),
    residenciaBarrio: new UntypedFormControl('', [Validators.required]),
    residenciaCiudadID: new UntypedFormControl(''),
    residenciaTelefono: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('')
  });

  datosBasicosForm: UntypedFormGroup = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    todosCheck: new UntypedFormControl(false),
    fechaNac: new UntypedFormControl({value: '', disabled: true}),
    rh: new UntypedFormControl({value: '', disabled: true}, [Validators.required]),
    tipoDocumento: new UntypedFormControl({value: '', disabled: true}),
    documento: new UntypedFormControl({value: '', disabled: true}, [Validators.required]),
    lugarDocID: new UntypedFormControl({value: '', disabled: true}),
    type: new UntypedFormControl(''),
    fechaLugarNacimiento: new UntypedFormControl(''),
    identificacion: new UntypedFormControl(''),
  });

  datosPadresForm: Array<UntypedFormGroup>;

  datosAcudienteForm: UntypedFormGroup = new UntypedFormGroup({
    id: new UntypedFormControl(''),
    todosCheck: new UntypedFormControl(''),
    acudiente: new UntypedFormControl('', [Validators.required]),
    acudienteTel: new UntypedFormControl('', [Validators.required]),
    acudienteTelMovil: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl('')
  });

  datosActualizacion$: Observable<{
    hijo: PersonaUpdate,
    padres: Array<PersonaUpdate>;
  }>;

  hijos$: Observable<Array<PersonaUpdate>>;

  currentView$: Observable<string>;

  alumnoId: number;

  private subscriptions: Array<Subscription> = new Array();

  private guardandoSubject = new BehaviorSubject('false');
  guardando$ = this.guardandoSubject.asObservable();
  stepper: string;

  constructor(
    private actualizacionService: ActualizacionDatosService,
    private router: Router,
    private route: ActivatedRoute) {
      this.datosPadresForm = new Array<UntypedFormGroup>();
      this.returnUrl = this.route.snapshot.paramMap.get('returnUrl');
    }

  ngOnInit() {
    this.hijos$ = this.actualizacionService.updateDataHijos$.pipe(
      toArray()
    );


    const alumno$ = this.route.params.pipe(
      map(params => +params['id']),
      tap(id => this.alumnoId = id)
    );

    this.currentView$ = this.route.params.pipe(
      map(params => params['view']),
    );

    this.datosActualizacion$ = combineLatest([alumno$, this.actualizacionService.updateData$]).pipe(
      map(([id, data]) => {
        return data.find(item => +item.hijo.id === id);
      }),
      tap(data => {
        if (this.datosPadresForm.length === 0) {
          data?.padres?.forEach((item) => {
            this.datosPadresForm.push(new UntypedFormGroup({
              id: new UntypedFormControl(''),
              todosCheck: new UntypedFormControl(''),
              genero: new UntypedFormControl(''),
              nombres: new UntypedFormControl({value: '', disabled: true}, [Validators.required]),
              apellidoP: new UntypedFormControl({value: '', disabled: true}, [Validators.required]),
              apellidoS: new UntypedFormControl({value: '', disabled: true}, [Validators.required]),
              tipoDocumento: new UntypedFormControl({value: '', disabled: true}),
              documento: new UntypedFormControl({value: '', disabled: true}, [Validators.required]),
              lugarDocID: new UntypedFormControl({value: '', disabled: true}),
              empresaNombre: new UntypedFormControl(''),
              empresaCargo: new UntypedFormControl(''),
              empresaProfesion: new UntypedFormControl(''),
              empresaDireccion: new UntypedFormControl(''),
              telefonoMovil: new UntypedFormControl('', [Validators.required]),
              eMail: new UntypedFormControl('', [Validators.required]),
              type: new UntypedFormControl(''),
              nombresApellidos: new UntypedFormControl(''),
              identificacion: new UntypedFormControl(''),
            }));
          });
        }
        this.formUpdateHijo(data?.hijo);
        data?.padres?.forEach((item, index) => {
          this.formUpdatePadres(item, index);
        });
        this.datosPadresForm.forEach(form => this.subscribeGuardadoOnCheck(form));
      })
    );
    this.datosActualizacion$.subscribe();

    this.subscribeGuardadoOnCheck(this.datosUbicacionForm);
    this.subscribeGuardadoOnCheck(this.datosAcudienteForm);

  }

  subscribeGuardadoOnCheck(form: UntypedFormGroup) {
    this.subscriptions.push(form.get('todosCheck').valueChanges.subscribe(res => {
      if (form.get('todosCheck').dirty) {
        if (res === true) {
          this.guardarForm(form, form.get('type').value);
        }
      }
    }));
  }

  formUpdatePadres(item: PersonaUpdate, index: number) {
    this.datosPadresForm[index].setValue({
      id: item.id,
      todosCheck: false,
      genero: item.sexo,
      nombres: item.nombres,
      apellidoP: item.apellidoP,
      apellidoS: item.apellidoS,
      tipoDocumento: item.tipoDocumento,
      documento: item.documento,
      lugarDocID: item.lugarDocID,
      empresaNombre: item.empresaNombre,
      empresaCargo: item.empresaCargo,
      empresaProfesion: item.empresaProfesion,
      empresaDireccion: item.empresaDireccion,
      telefonoMovil: item.telefonoMovil,
      // Email contacto
      eMail: item.eMail,
      type: 'familia',
      nombresApellidos: item.nombresApellidos,
      identificacion: item.identificacion,
    });
  }

  formUpdateHijo(hijo: PersonaUpdate) {
    this.datosUbicacionForm.setValue({
      id: hijo.id,
      todosCheck: hijo.allChildAddress,
      residenciaDireccion: hijo.residenciaDireccion,
      residenciaBarrio: hijo.residenciaBarrio,
      residenciaCiudadID: hijo.residenciaCiudadID,
      residenciaTelefono: hijo.residenciaTelefono,
      type: 'ubicacion'
    });
    this.datosBasicosForm.setValue({
      id: hijo.id,
      todosCheck: false,
      fechaNac: hijo.fechaNac,
      rh: hijo.rh,
      tipoDocumento: hijo.tipoDocumento,
      documento: hijo.documento,
      lugarDocID: hijo.lugarDocID,
      type: 'basico',
      fechaLugarNacimiento: hijo.fechaLugarNacimiento,
      identificacion: hijo.identificacion,
    });

    this.datosAcudienteForm.setValue({
      id: hijo.id,
      todosCheck: hijo.allChildAcudiente,
      acudiente: hijo.acudiente,
      acudienteTel: hijo.acudienteTel,
      acudienteTelMovil: hijo.acudienteTelMovil,
      type: 'acudiente'
    });
  }

  labelPadres(sexo: number): string {
    return `Datos ${ sexo === 2 ? 'del padre' : 'de la madre'}`;
  }

  navegarHijo(id: number) {
    this.datosAcudienteForm.markAsPristine();
    this.datosBasicosForm.markAsPristine();
    this.datosUbicacionForm.markAsPristine();
    this.datosPadresForm.forEach(item => item.markAsPristine());
    this.router.navigate(['/actualizacion/alumno/', id, this.returnUrl, 'default']);
  }

  navegarView(identifier: string) {
    this.router.navigate(['/actualizacion/alumno/', this.alumnoId, this.returnUrl, identifier]);
  }

  guardarForm(form: UntypedFormGroup, type: string) {
    // TODO: encapsular
    this.guardandoSubject.next('true');
    const value = form.value;
    if (form.get('todosCheck').value === true) {
      this.hijos$.subscribe(res => {
        res.forEach(hijo => {
          value.id = hijo.id;
          if (type === 'acudiente') {
            value.allChildAcudiente = true;
          }
          if (type === 'ubicacion') {
            value.allChildAddress = true;
          }
          this.actualizacionService.guardar(value, isNaN(+type) ? type : 'familia').subscribe(
            response => {
              form.markAsPristine();
              this.guardandoSubject.next('false');
            },
            error => {
              this.guardandoSubject.next('false');
            }
          );
        });
      });
    } else {

      if (type === 'acudiente') {
        value.allChildAcudiente = false;
      }
      if (type === 'ubicacion') {
        value.allChildAddress = false;
      }
      this.actualizacionService.guardar(value, isNaN(+type) ? type : 'familia').subscribe(
        res => {
          form.markAsPristine();
          this.guardandoSubject.next('false');
        },
        error => {
          this.guardandoSubject.next('false');
        }
      );
    }
  }

  volver(): void {
    this.router.navigateByUrl(this.returnUrl);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item => item.unsubscribe());
  }

  public isDirty(): boolean {
    let padresDirty = false;
    this.datosPadresForm.forEach(element => {
        padresDirty = padresDirty || element.dirty;
    });
    return this.datosAcudienteForm.dirty || this.datosUbicacionForm.dirty || padresDirty;
  }
}
